import React, { useState } from 'react';
// --- 1. DADOS DE AUTENTICAÇÃO ---
import { useAuth } from '../../Context/AuthContext'; 
import * as XLSX from 'xlsx';

// --- 2. LISTA DE ADMINISTRADORES ---
const ADMINS_CPF = [
  '12345678900', // tauan.santos
  '15521631488', // victor.vicente
  '09733705489', // gilson.souza
  '05754574495', // vitor.dias
  '04713835463', // marcia.gabriel
  '02860672427', // fabiano.leite
  '11150844450', // Maria.pinheiro
];
const ADMINS_ID = [
  '78645439',   // tauan.santos
  '78675321', // victor.vicente
  '78663761', // gilson.souza
  '131656', // vitor.dias
  '130416', // marcia.gabriel
  '78634589', // fabiano.leite
  '78674651', // Maria.pinheiro
];

export function LogPedidos() {
  const [baixando, setBaixoando] = useState(false);
  const { usuario } = useAuth(); 

  // --- 3. VERIFICAÇÃO DE PERMISSÃO ---
  const cpfUsuario = usuario?.CON_NusCICNumero?.replace(/\D/g, '') || '';
  const idUsuario = usuario?.CON_CdiContratado?.toString() || '';
  
  const podeBaixar = ADMINS_CPF.includes(cpfUsuario) || ADMINS_ID.includes(idUsuario);

  async function baixarPedidos() {
    setBaixoando(true);
    try {
      const url = '/logPedidos.php';
      const resp = await fetch(url, { cache: 'no-cache' });

      if (!resp.ok) {
        throw new Error(`O servidor respondeu com um erro: ${resp.status}`);
      }

      const data = await resp.json();

      if (!data.rows || !Array.isArray(data.rows) || data.rows.length === 0) {
        alert("A API retornou um histórico vazio.");
        setBaixoando(false);
        return;
      }
      
      // --- ALTERAÇÃO AQUI: INÍCIO ---
      // Usaremos um Set para armazenar uma "chave única" de cada pedido já processado.
      const pedidosProcessados = new Set();
      // --- ALTERAÇÃO AQUI: FIM ---

      const xlsxRows = [];
      data.rows.forEach((pedido) => {
        let params = {};
        if (typeof pedido.template_params === 'string') {
          try {
            params = JSON.parse(pedido.template_params);
          } catch (e) { params = {}; }
        } else if (typeof pedido.template_params === 'object' && pedido.template_params !== null) {
          params = pedido.template_params;
        }

        // --- ALTERAÇÃO AQUI: INÍCIO ---
        // Criamos uma chave única para o pedido combinando dados que não se repetem
        // para o mesmo pedido em um curto espaço de tempo.
        const chavePedidoUnico = `${params.to_email}-${pedido.created_at}`;

        // Se já processamos um pedido com esta chave, pulamos para o próximo.
        if (pedidosProcessados.has(chavePedidoUnico)) {
          return; // 'return' dentro de um forEach funciona como 'continue' em um loop for.
        }
        // Se não, adicionamos a chave ao nosso controle para evitar futuras duplicatas.
        pedidosProcessados.add(chavePedidoUnico);
        // --- ALTERAÇÃO AQUI: FIM ---

        const itensHtml = params.itens_html || '';
        const regexLinhas = /<tr>\s*<td.*?>(.*?)<\/td>\s*<td.*?>(.*?)<\/td>\s*<td.*?>(.*?)<\/td>\s*<td.*?>(.*?)<\/td>\s*<td.*?>(.*?)<\/td>\s*<\/tr>/gs;
        let match;
        let temItens = false;

        while ((match = regexLinhas.exec(itensHtml)) !== null) {
          temItens = true;
          const produtoHtml = match[1];
          const corTamanho = match[2];
          const quantidade = match[3].replace(/<.*?>/g, '').trim();
          const precoUnitario = match[4].replace(/<.*?>/g, '').trim();
          const nomeProduto = produtoHtml.replace(/<img.*?>|<div.*?>.*?<\/div>/gs, '').trim();
          
          xlsxRows.push({
            // Mantive seu ID de e-mail aqui, mas o controle de duplicidade é feito pela chave que criamos.
            ID_Email: pedido.id, 
            Nome_Cliente: params.nome_completo || '',
            ID_Contratado: params.id_contratado || '',
            Email_Cliente: params.to_email || '',
            Telefone_Cliente: params.telefone || '',
            ID_Centro_Custo: params.id_centrocusto || '',
            Centro_Custo: params.nome_centrocusto || '',
            Total_Pedido: params.total_carrinho || '',
            Data_Pedido: pedido.created_at,
            Produto: nomeProduto,
            Cor_Tamanho: corTamanho,
            Quantidade: quantidade,
            Preco_Unitario: precoUnitario,
          });
        }

        if (!temItens) {
          xlsxRows.push({
            ID_Email: pedido.id,
            Nome_Cliente: params.nome_completo || '',
            ID_Contratado: params.id_contratado || '',
            Email_Cliente: params.to_email || '',
            Telefone_Cliente: params.telefone || '',
            ID_Centro_Custo: params.id_centrocusto || '',
            Centro_Custo: params.nome_centrocusto || '',
            Total_Pedido: params.total_carrinho || '',
            Data_Pedido: pedido.created_at,
            Produto: 'N/A',
            Cor_Tamanho: 'N/A',
            Quantidade: 'N/A',
            Preco_Unitario: 'N/A',
          });
        }
      });
      
      if (xlsxRows.length === 0) {
        alert("Nenhum item de pedido encontrado para exportar.");
        setBaixoando(false);
        return;
      }
      
      const ws = XLSX.utils.json_to_sheet(xlsxRows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Detalhes dos Pedidos");
      XLSX.writeFile(wb, "log-pedidos-detalhado.xlsx");

    } catch (err) {
      alert("Falha ao baixar pedidos: " + err.message);
      console.error('[LogPedidos] Erro:', err);
    } finally {
      setBaixoando(false);
    }
  }

  // --- 4. RENDERIZAÇÃO CONDICIONAL ---
  if (!podeBaixar) {
    return null;
  }

  return (
    <button
      className="btn btn-outline-primary ms-3"
      onClick={baixarPedidos}
      disabled={baixando}
      style={{ borderRadius: '20px', fontWeight: '600' }}
    >
      {baixando ? "Baixando..." : "Baixar Pedidos"}
    </button>
  );
}